import { makeAutoObservable, runInAction } from 'mobx';
import type { RootStore } from './root-store';
import { OnboardingCaseEnum } from '../enums/onboarding-case-enum';
import { AddTradesOnboardingSubcaseEnum } from '../enums/add-trades-onboarding-subcase-enum';

export class OnboardingStore {
    rootStore: RootStore;

    run = false;

    case: OnboardingCaseEnum = OnboardingCaseEnum.AddTrades;

    addTradesSubcase: AddTradesOnboardingSubcaseEnum = AddTradesOnboardingSubcaseEnum.start;

    stepIndex = 0;

    private timeoutId?: NodeJS.Timeout;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;

        makeAutoObservable(this, {
            rootStore: false,
        });
    }

    startOnboarding(onboardingCase: OnboardingCaseEnum) {
        runInAction(() => {
            this.case = onboardingCase;
            if (onboardingCase === OnboardingCaseEnum.AddTrades) {
                this.addTradesSubcase = AddTradesOnboardingSubcaseEnum.start;
            }

            this.stepIndex = 0;
            this.run = true;
        });
    }

    async stopOnboarding() {
        this.run = false;
        const step = this.stepIndex;
        this.stepIndex = 0;

        window.localStorage.setItem('onboardingClosed', 'true');

        if (this.case === OnboardingCaseEnum.AddTrades) {
            // Close any open modals when onboarding ends
            if (this.addTradesSubcase === AddTradesOnboardingSubcaseEnum.import) {
                const { tradeImportDialogStore } = this.rootStore.tradeStore;
                if (tradeImportDialogStore.opened) {
                    tradeImportDialogStore.closeImportDialog();
                }
            } else if (this.addTradesSubcase === AddTradesOnboardingSubcaseEnum.manual) {
                const { tradeDialogStore } = this.rootStore.tradeStore;
                if (tradeDialogStore.createDialogOpened) {
                    tradeDialogStore.closeCreateDialog();
                }
            }

            await this.rootStore.apiClient.eventLogController.eventLogControllerCreateLog({
                createEventLogDto: {
                    namespace: 'onboarding',
                    key: `${this.case}:${this.addTradesSubcase}:${step}`,
                    metaData: {
                        userId: this.rootStore.authStore.userProfile?.id,
                    },
                },
            });
        }
    }

    setStep(stepIndex: number) {
        this.stepIndex = stepIndex;
    }

    isOnboardingRunning(onboardingCase: OnboardingCaseEnum, addTradesSubcase?: AddTradesOnboardingSubcaseEnum) {
        const isCaseRunning = this.run && this.case === onboardingCase;

        if (addTradesSubcase) {
            return isCaseRunning && addTradesSubcase === this.addTradesSubcase;
        }

        return isCaseRunning;
    }

    setAddTradesSubcase(subcase: AddTradesOnboardingSubcaseEnum) {
        this.addTradesSubcase = subcase;
        this.setStep(0);
    }
}
